export const refreshButton = () => {
      window.location.reload();
    };